export const phones = (str: string): string => str.replace(/\D/g, '')
// приведение телефона к нужному формату
export const formatPhoneNumber = (phoneNumber: string): string => {
  let phone = phoneNumber.replace(/\D/g, '')

  if (phone.length === 11) {
    phone = '+' + phone

    return `${phone.substring(0, 2)} (${phone.substring(
      2,
      5,
    )}) ${phone.substring(5, 8)}-${phone.substring(8, 10)}-${phone.substring(
      10,
    )}`
  }

  return phone
}
